import { AfterViewInit, Component, ViewChild, inject } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { MenuService } from '../services/menu.service';

@Component({
    selector: 'app-body',
    templateUrl: './body.component.html',
    styleUrls: ['./body.component.scss'],
    standalone: false,
})
export class BodyComponent implements AfterViewInit {
    private menuService = inject(MenuService);

    @ViewChild('sidenav') sidenav: MatSidenav;

    ngAfterViewInit() {
        this.menuService.setMenu(this.sidenav);
    }
}
